import type { GetSiteResponse } from '@/contracts/site.contract'
import { request } from './http/client'

/**
 * 站台資訊。
 *
 * 開站時打一次，用來知道「我在哪個站、這個站現在能不能用」。
 * 後端刻意回 `Cache-Control: no-store` —— 維護狀態要立刻讓所有人看到，
 * 所以這支不做任何前端快取。
 */
export const siteApi = {
  get(): Promise<GetSiteResponse> {
    return request<GetSiteResponse>({ method: 'GET', url: '/api/v1/site' })
  },
}
